import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { AuthContext } from "../contexts/AuthContext";
import { Snackbar } from "@mui/material";

export default function Authentication() {
	// for form
	const [username, setUsername] = React.useState();
	const [password, setPassword] = React.useState();
	const [name, setName] = React.useState();
	const [error, setError] = React.useState();
	const [message, setMessage] = React.useState();

	// to create a form
	const [formState, setFormState] = React.useState(0);
	// for snackbar ie toast
	const [open, setOpen] = React.useState(false);

	// inside the form handling
	const { handleRegister, handleLogin } = React.useContext(AuthContext);

	let handleAuth = async () => {
		try {
			if (formState === 0) {
				await handleLogin(username, password);
			}
			if (formState === 1) {
				let result = await handleRegister(name, username, password);
				console.log(result);
				setUsername("");
				setMessage(result);
				setOpen(true);
				setError("");
				setFormState(0);
				setPassword("");
			}
		} catch (err) {
			console.log(err);
			let message = err.response.data.message;
			setError(message);
		}
	};

	return (
		<>
			<Grid
				container
				component="main"
				sx={{
					height: "100vh",
					background:
						"radial-gradient(circle at top left, rgba(26, 115, 232, 0.08) 0%, #0a0a0a 60%)",
				}}
			>
				<Grid
					item
					xs={false}
					sm={4}
					md={7}
					sx={{
						display: { xs: "none", sm: "flex" },
						alignItems: "center",
						justifyContent: "center",
						color: "text.primary",
						px: 6,
					}}
				>
					<Box
						sx={{
							maxWidth: 420,
						}}
					>
						<Typography
							variant="h3"
							fontWeight={700}
							gutterBottom
							sx={{ color: "#F97316" }}
						>
							AK Meet
						</Typography>
						<Typography
							variant="h6"
							color="text.secondary"
							sx={{ mb: 4, fontWeight: 400 }}
						>
							Fast, simple and secure video calls built for
							learners and creators.
						</Typography>
						<img
							src="./undraw_login_weas.svg"
							alt="AK Meet login illustration"
							style={{
								width: "100%",
								height: "auto",
								opacity: 0.85,
							}}
						/>
					</Box>
				</Grid>
				<Grid
					item
					xs={12}
					sm={8}
					md={5}
					component={Paper}
					elevation={8}
					square
					sx={{
						backgroundColor: "#171717",
						borderLeft: "1px solid rgba(255, 255, 255, 0.08)",
						display: "flex",
						alignItems: "center",
					}}
				>
					<Box
						sx={{
							my: 6,
							mx: { xs: 3, sm: 6 },
							display: "flex",
							flexDirection: "column",
							alignItems: "stretch",
							width: "100%",
						}}
					>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								mb: 3,
							}}
						>
							<Avatar sx={{ mb: 1, bgcolor: "primary.main" }}>
								<LockOutlinedIcon />
							</Avatar>
							<Typography component="h1" variant="h5">
								{formState === 0
									? "Welcome back"
									: "Create your account"}
							</Typography>
						</Box>

						<Box
							sx={{
								display: "flex",
								gap: 1.5,
								mb: 3,
								bgcolor: "rgba(255, 255, 255, 0.02)",
								p: 0.75,
								borderRadius: 999,
							}}
						>
							<Button
								fullWidth
								variant={formState === 0 ? "contained" : "text"}
								onClick={() => {
									setFormState(0);
									setError("");
								}}
							>
								Sign in
							</Button>
							<Button
								fullWidth
								variant={formState === 1 ? "contained" : "text"}
								onClick={() => {
									setFormState(1);
									setError("");
								}}
							>
								Sign up
							</Button>
						</Box>

						<Box component="form" noValidate sx={{ mt: 1 }}>
							{formState === 1 ? (
								<TextField
									margin="normal"
									required
									fullWidth
									id="full-name"
									label="Full name"
									name="fullName"
									value={name}
									autoFocus
									onChange={(e) => setName(e.target.value)}
								/>
							) : null}

							<TextField
								margin="normal"
								required
								fullWidth
								id="username"
								label="Username"
								name="username"
								value={username}
								autoFocus={formState === 0}
								onChange={(e) => setUsername(e.target.value)}
							/>
							<TextField
								margin="normal"
								required
								fullWidth
								name="password"
								label="Password"
								value={password}
								type="password"
								onChange={(e) => setPassword(e.target.value)}
								id="password"
							/>

							{error ? (
								<Typography
									variant="body2"
									color="error"
									sx={{ mt: 1 }}
								>
									{error}
								</Typography>
							) : null}

							<Button
								type="button"
								fullWidth
								variant="contained"
								sx={{ mt: 3, mb: 2 }}
								onClick={handleAuth}
							>
								{formState === 0 ? "Login" : "Register"}
							</Button>
						</Box>
					</Box>
				</Grid>
			</Grid>

			<Snackbar open={open} autoHideDuration={4000} message={message} />
		</>
	);
}
